import React, {useState} from "react";
import {Col, Row, Button} from "react-bootstrap";

import {InputWithLabel} from "../../component/Form/InputWithLabel";
import Icon from "../../component/Icon/Icon";
import {ModalMessage} from "../../component/Modal/ModalMessage";
import ProductTypeService from "../../productType/ProductTypeService";
import Notify from "../../services/Notify";
import ModalMessageNew from "../../component/Modal/ModalMessageNew";

class GridProductTypes {

  constructor() {
    this.productTypeService = new ProductTypeService()
  }

  title = 'Lista de Tipo de Produtos';

  customFilters = {}

  exportNewPage = true;
  showPdfButton = false;

  columns = [
    {
      Header: "Referência",
      accessor: "reference",
      HeaderColumn: true,
    },
    {
      Header: "Descrição",
      accessor: "friendlyName"
    },
    {
      Header: "Unidade de Medida",
      accessor: "unitType"
    },
    {
      Header: "Ativo",
      accessor: "active",
      Cell: row => (
        <h4>
          {row.original.active ? "Ativo" : "Inativo"}
        </h4>
      ),
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => {
        const [showModal, setShowModal] = useState(false)
        const handleDeleteProductType = async (productTypeId) => {
          try {
            await this.productTypeService.deleteById(productTypeId)
            this.forceReload()
            Notify.success("Local deletado com sucesso!")
          } catch (error) {
            Notify.error("Houve um erro ao deletar o local, por favor tente novamente mais tarde.", error)
          } finally {
            setShowModal(false)
          }
        }
        const handleShowModal = () => setShowModal(!showModal)
        return (
          <Row>
            <Col lg={6}>
              <Button title="Editar" bsStyle="success" href={`#/product-types/${row.original.id}/edit`} block>
                <Icon icon="pencil"/>
              </Button>
            </Col>
            <Col lg={6}>
              <Button onClick={handleShowModal} title="Excluir" bsStyle="danger" block>
                <Icon icon="trash"/>
              </Button>
            </Col>
            <ModalMessageNew
              showModal={showModal}
              handleShowModal={handleShowModal}
              errorButtonAction={handleShowModal}
              successButtonAction={() => handleDeleteProductType(row.original.id)}
              title={`Tem certeza que deseja deletar o tipo de produto ${row.original.reference} - ${row.original.friendlyName} ?`}
            />
          </Row>
        )
      }
    }
  ];

  customFilterComponent = (props, state, onChange) => {
    return (
      <Row>
        <Col md={6}>
          <InputWithLabel label="Referência" placeholder="Digite a referência" onChangeWithDelay={e => {
            this.customFilters.reference = e && e.trim()
            onChange(this.customFilters)
          }}/>
        </Col>
        <Col md={6}>
          <InputWithLabel label="Descrição" placeholder="Digite a descrição" onChangeWithDelay={e => {
            this.customFilters.friendlyName = e && e.trim()
            onChange(this.customFilters)
          }}/>
        </Col>
      </Row>
    )
  }

  endpoint = () => {
    const params = new URLSearchParams({})
    const {friendlyName, reference} = this.customFilters

    reference && params.append('reference', reference)
    friendlyName && params.append('friendlyName', friendlyName)

    return `ton/v1/product-types?${params.toString()}`;
  }
}

export default GridProductTypes;



// WEBPACK FOOTER //
// ./src/customGrid/entities/ProductTypes.js